import {types} from '../actions/types';

const initialState = {
  loading: false,
  data: {},
  error: {},
};

const saveFeedbackReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case types.SEND_REQUEST_SAVE_FEEDBACK:
      return {
        ...state,
        loading: true,
      };
    case types.SEND_REQUEST_SAVE_FEEDBACK_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case types.SEND_REQUEST_SAVE_FEEDBACK_FAILURE:
      return {
        ...state,
        data: {},
        error: payload,
        loading: false,
      };
      case types.CLEAR_REQUEST_SAVE_FEEDBACK:
        return {
          ...state,
          data: {},
          loading: false,
        };
    default:
      return state;
  }
};

export default saveFeedbackReducer
